import { render, staticRenderFns } from "./TrancheCapitalCall.vue?vue&type=template&id=6d7817ee&scoped=true&"
import script from "./TrancheCapitalCall.vue?vue&type=script&lang=js&"
export * from "./TrancheCapitalCall.vue?vue&type=script&lang=js&"
import style0 from "./TrancheCapitalCall.vue?vue&type=style&index=0&id=6d7817ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7817ee",
  null
  
)

export default component.exports